import { createFileRoute } from '@tanstack/react-router';
import MyFinishedMissionsPage from '../../features/environmental-cleaning/pages/MyFinishedMissionsPage';
import { getMyFinishedCleaningMissionsTodayQueryOptions } from '../../features/environmental-cleaning/queries';

export const Route = createFileRoute('/_auth/environmental-cleaning/done')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { user } = context.authenticationContext;
    if (!user) {
      return;
    }
    await context.queryClient.ensureQueryData(getMyFinishedCleaningMissionsTodayQueryOptions(user, new Date()));
  },
});

function RouteComponent() {
  const { user } = Route.useRouteContext().authenticationContext;
  if (!user) {
    return null;
  }
  return <MyFinishedMissionsPage user={user} />;
}
